import { AnyAction, combineReducers, configureStore, PreloadedState } from '@reduxjs/toolkit';
import { journeyReducer } from './features/journey';
import { journeysReducer } from './features/journeys';
import { notificationsReducer } from './features/notifications/notifications-slice';
import { scheduleReducer } from './features/schedule/schedule-slice';
import { singInReducer } from './features/singin/singin-slice';
import { oyanaReducer } from './features/me/me-slice';
import { anamneseReducer } from './features/anamnese';
import { redirectReducer } from './features/redirect';
import { fileUploadReducer } from './features/fileUpload';
import { calendarReducer } from './features/calendar/calendar-slice';
import { currentScheduleReducer } from './features/currentSchedule/currentSchedule-slice';

import { api, rtkQueryErrorLogger } from './services/api.service';

import { api as anamneseApi } from './services/anamnese.api.service';

const appReducer = combineReducers({
  calendar: calendarReducer,
  journey: journeyReducer,
  journeys: journeysReducer,
  schedule: scheduleReducer,
  currentSchedule: currentScheduleReducer,
  singIn: singInReducer,
  notifications: notificationsReducer,
  oyana: oyanaReducer,
  anamnese: anamneseReducer,
  redirect: redirectReducer,
  fileUpload: fileUploadReducer,
  [api.reducerPath]: api.reducer,
  [anamneseApi.reducerPath]: anamneseApi.reducer
});

export const RESET_SESSION = 'session/reset';
export const resetSession = () => ({ type: RESET_SESSION });

/**
 * clear Redux state (perfil, arquivos, jornadas, cache do RTK Query, etc.)
 */
const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: AnyAction) =>
  appReducer(action.type === RESET_SESSION ? undefined : state, action);

export function setupStore(preloadedState?: PreloadedState<RootState>) {
  return configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(api.middleware).concat([rtkQueryErrorLogger]).concat(anamneseApi.middleware),
    preloadedState
  });
}

export type RootState = ReturnType<typeof appReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
